import { ColumnResizer } from '@column-resizer/core';
import * as React from 'react';

export const ColumnResizerContext = React.createContext<ColumnResizer | null>(null);
